import { getCurrentSubdomain } from '@/http/Subdomain';
export const ChangiRecommends_CATALOG_UUID = 'd5455bbe-0ad3-437d-a1a8-99d39a2d27e0';
export const ChangiRecommends_CATALOG_ID = 3;
const URL_SUBDOMAIN = getCurrentSubdomain();
export const ChangiRecommends_SALES_CODE = URL_SUBDOMAIN;
